import { Typography } from 'app/components/ui';
import './QuickStatsBox.scss';
import { i18n } from 'app/utils/i18n';

interface QuickStat {
  type: string;
  label: string;
  value: number;
  total: number;
}

export const QuickStatsBox = ({ type, label, value, total }: QuickStat) => {
  const percentage = total > 0 ? (value / total) * 100 : 0;

  return (
    <div className={`quick-stat quick-stat--${type}`}>
      <div className="quick-content">
        <Typography variant="body-5" fontWeight="light">
          <span style={{ fontSize: 18 }}>{value}</span> {i18n('all.tags.tags')}
        </Typography>
        <Typography variant="body-7" fontWeight="extra-light">
          {label}
        </Typography>
      </div>

      <div className={`quick-indicator`}>
        <span style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
};
